var keyMirror = require('keymirror');

module.exports = keyMirror({
	LINE_CHART: null,
	LINE_CHART_CSV: null,
	UNIVERSAL_INSIGHT_CSV: null
});